<template>
  <div class="card">
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <form>
      <div class="card-content">
        <div class="row">
          <div class="col-md-6">

            <div class="form-group">
              <label>{{$t('marketingOffers.title')}}</label>
              <input type="text"
                     name="title"
                     :placeholder="$t('marketingOffers.title')"
                     v-model="model.title"
                     class="form-control">
            </div>

            <div class="form-group">
              <label>{{$t('marketingOffers.startEndDate')}}</label><br>
              <el-date-picker type="daterange"
                              v-model="model.fromto"
                              value-format="yyyy-MM-dd"
                              format="dd/MM/yyyy"
                              :picker-options="pickerOptions">
              </el-date-picker>
              <small class="text-danger" v-if="errors.has('date_start')">
                {{ getError('date_start') }}
              </small>
            </div>

            <div class="form-group">
              <label>{{$t('marketingOffers.image')}}</label>
              <el-upload
                action=""
                ref="upload"
                :limit="2"
                :file-list="model.imagelist"
                list-type="picture-card"
                accept=" .jpg, .jpeg, .png"
                :on-change="handleImgChange"
                :on-exceed="handleExceed"
                :on-remove="handleRemove"
                v-validate="modelValidations.imagelist"
                :auto-upload="false">
                <i class="el-icon-plus"></i>
                <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}{{$t('validations.imageResolution')}}</div>
              </el-upload>
              <small class="text-danger" v-if="errors.has('image')">
                {{ getError('image') }}
              </small>
            </div>

            <div class="form-group">
              <label>{{$t('marketingOffers.imageWeb')}}</label>
              <el-upload
                action=""
                ref="upload"
                :limit="1"
                :file-list="model.imageWeb"
                list-type="picture-card"
                accept=" .jpg, .jpeg, .png"
                :on-change="handleImgChangeWeb"
                :on-exceed="handleExceed"
                :on-remove="handleRemoveWeb"
                :auto-upload="false">
                <i class="el-icon-plus"></i>
                <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}{{$t('validations.imageResolutionWeb')}}</div>
              </el-upload>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{$t('marketingOffers.linkType')}}</label>
              <select class="form-control" v-model="model.link_type" @change="clearLinkSelection()">
                <option>- {{$t('general.select')}} -</option>
                <option value="category">{{$t('marketingOffersTypes.category')}}</option>
                <option value="product">{{$t('marketingOffersTypes.product')}}</option>
                <option value="page">{{$t('marketingOffersTypes.page')}}</option>
              </select>
              <small class="text-danger" v-if="errors.has('link_type')">
                {{ getError('link_type') }}
              </small>
            </div>
             <div class="form-group" v-if="model.link_type == 'page'">
              <label>{{$t('marketingOffers.pageText')}}</label>
              <textarea rows="5"
                     name="description"
                     placeholder=""
                     v-validate="modelValidations.description"
                     v-model="model.description"
                     class="form-control"></textarea>
              <small class="text-danger" v-if="errors.has('description')">
                {{ getError('description') }}
              </small>
            </div>
            <div class="form-group" v-if="model.link_type == 'category'">
              <label>{{$t('marketingOffers.pickCateg')}}</label>
              <select name="" class="form-control"
                            v-model="model.link_id">
                <option :value="null" :selected="true">{{$t('marketingOffers.none')}}</option>
                <template v-for="option in categories">
                  <option
                             :selected="option.id === model.link_id"
                             :value="option.id"
                             :label="option.name"
                             :key="option.id"></option>
                </template>
              </select>
              <small class="text-danger" v-if="errors.has('link_id')">
                {{ getError('link_id') }}
              </small>
            </div>
            <div class="form-group" v-if="model.link_type == 'product'">
              <label>{{$t('marketingOffers.pickProd')}}</label>
              <select name="" class="form-control"
                            v-model="model.link_id">
                <option :value="null" :selected="true">{{$t('marketingOffers.none')}}</option>
                <template v-for="option in products">
                  <option
                             :selected="option.id === model.link_id"
                             :value="option.id"
                             :label="option.name"
                             :key="option.id"></option>
                </template>
              </select>
              <small class="text-danger" v-if="errors.has('link_id')">
                {{ getError('link_id') }}
              </small>
            </div>
            <div class="form-group" v-if="locations.length > 1">
              <label>{{$t('marketingOffers.pickLoc')}}</label>
              <v-select v-model="model.location_ids"
                        multiple
                        :options="locations"
                        label="name"
                        :placeholder="$t('general.all')">
              </v-select>
            </div>
            <input type="hidden" name="offer_id" :value="$route.params.offer_id">
          </div>
        </div>
      </div>

      <div class="card-footer " >
        <button type="submit" @click.prevent="validate" :title="$t('general.save')" class="btn btn-icon btn-success"><i class="ti-save"></i></button>
        <a v-if="!isNew()" @click.prevent="handleDelete($t('general.delete'))" :title="$t('general.delete')" class="btn btn-danger btn-icon"><i class="ti-close"></i></a>
        <a v-if="isNew()" @click.prevent="handleDelete($t('general.cancel'))" :title="$t('general.cancel')" class="btn btn-danger btn-icon"><i class="ti-close"></i></a>
        <div style="clear: both"></div>
      </div>

    </form>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Checkbox, CheckboxGroup, Dialog} from 'element-ui'
  // import moment from 'moment'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dialog)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Dialog.name]: Dialog
    },
    computed: {
      ...mapFields(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        pickerOptions1: {},
        pickerNames: ['date_validfrom', 'date_validto'],
        pickerOptions: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        model: {
        },
        filelist: [],
        filelistToUpload: [],
        generalSuccess: '',
        modelValidations: {
          image: {
            required: true
          }
        },
        categories: [],
        products: [],
        loading: true,
        locations: [],
        imageWeb: []
      }
    },
    created: function () {
      this.locations = this.getCompanyDetail('locations_details')
      this.$nextTick(function () { this.loading = true })

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      var self = this
      // get main categories
      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          self.categories = response.data
        }
      })
      this.apiRequest('/product', 'GET', data, function (response) {
        if (response.status === true) {
          self.products = response.data
        }
      })
      // get offer data
      if (this.route.params.id) {
        var id = this.route.params.id

        this.apiRequest('/homepage-offer/edit/' + id, 'GET', data, (response) => {
          if (response.status === true) {
            if (response.data[0].date_start && response.data[0].date_end) {
              response.data[0].fromto = [response.data[0].date_start, response.data[0].date_end]
            }
            if (response.data[0].image) {
              response.data[0].imagelist = [{url: response.data[0].image}]
            } else {
              response.data[0].imagelist = []
            }
            if (response.data[0].image_web) {
              response.data[0].imageWeb = [{url: response.data[0].image_web}]
            } else {
              response.data[0].imageWeb = []
            }
            this.model = response.data[0]

            this.$nextTick(function () { this.loading = false })
          }
        })
      } else {
        this.$nextTick(function () { this.loading = false })
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)
          if (isValid) {
            this.errors.clear()
            this.saveOffer()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0])
          } else {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      handleImgChangeWeb (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imageWeb = []
        } else {
          if (fileList.length > 1) {
            this.model.imageWeb = fileList.slice(1)
          } else {
            this.model.imageWeb = fileList
          }
        }
      },
      handleImgChange (file, fileList) {
        // console.warn('handleImgChange')
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 1
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemoveWeb (file, fileList) {
        if (fileList.length === 0) {
          this.model.imageWeb = []
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      },
      handleDelete (label) {
        var btnCounter = 3
        var self = this
        swal({
          text: self.$t('marketingOffers.areYouSure', {label: label}),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              self.$router.push('/marketing/offers')
            } else {
              var id = this.route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/homepage-offer/delete-banner/' + id, 'DELETE', data, function (response) {
                // console.warn(response)
                if (response.status === true) {
                  swal(
                    '',
                    self.$t('validations.offerDeleted'),
                    'success'
                  )
                  self.$router.push('/marketing/offers')
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      clearLinkSelection () {
        // console.warn('clean')
        this.model.link_id = null
        this.model.description = null
      },
      saveOffer () {
        this.$nextTick(function () { this.loading = true })
        let locIds = []
        for (let idxL in this.model.location_ids) {
          locIds.push(this.model.location_ids[idxL]['id'])
        }
        locIds = JSON.stringify(locIds)

        var data = {
          title: this.model.title,
          link_type: this.model.link_type,
          link_id: this.model.link_id,
          description: this.model.description,
          location_ids: locIds,
          offer_id: this.route.params.offer_id
        }
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
          data.date_start = this.model.fromto[0]
          data.date_end = this.model.fromto[1]
        } else {
          data.date_start = null
          data.date_end = null
        }

        var self = this

        if (this.isNew()) {
          data.sort_order = 0
          if (self.model.imagelist && self.model.imagelist[0].status === 'ready') {
            self.getBase64(self.model.imagelist[0].raw).then(
              (base64enc) => {
                data.image = base64enc
                if (self.model.imageWeb && self.model.imageWeb[0].status === 'ready') {
                  self.getBase64(self.model.imageWeb[0].raw).then(
                    (base64enc) => {
                      data.imageWeb = base64enc
                    }
                  )
                }
                self.apiRequest('/homepage-offer/store', 'POST', data, function (response) {
                  if (response.status === true) {
                    self.$nextTick(function () { self.loading = false })
                    swal(
                      {
                        title: '',
                        text: self.$t('marketingOffers.offerAdded'),
                        type: 'success',
                        showConfirmButton: false,
                        timer: 1500
                      }
                    ).catch(() => {}) // end swal
                    var id = response.data[0].id
                    data.id = id
                    data.sort_order = id
                    self.apiRequest('/homepage-offer/update-banner' + id, 'PUT', data, function (response2) {
                    })
                    self.$router.push('/marketing/offers/' + response.data[0].offer_id + '/edit-group-banner/' + id)
                  } else {
                    self.$nextTick(function () { self.loading = false })
                    self.handleErrors(response.errors)
                  }
                }) // end api response
              }
            ) // end getBase64.then
          } else {
            self.$nextTick(function () { self.loading = false })
            self.errors.add('image', self.$t('marketingOffers.validImg'))
          }
        } else {
          var id = this.route.params.id
          // check if the've removed the picture
          if (this.model.imagelist === 0) {
            data.image = ''
          }
          if (this.model.imageWeb) {
            data.imageWeb = ''
          }
          this.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              if (self.model.imagelist[0] !== undefined && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc
                    // console.warn(data2)
                    self.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingOffers.offerUpdated'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingOffers.weCouldNot'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              }
              if (self.model.imageWeb[0] !== undefined && self.model.imageWeb[0].status && self.model.imageWeb[0].status === 'ready') {
                self.getBase64(self.model.imageWeb[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.imageWeb = base64enc
                    self.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingOffers.offerUpdated'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingOffers.weCouldNot'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                )
              }
              self.$nextTick(function () { self.loading = false })
              swal(
                {
                  title: '',
                  text: self.$t('marketingOffers.offerUpdated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
              // marketing/offers/1/edit-group-banner/9

              self.$router.push('/marketing/offers/ ' + this.route.params.offer_id + ' edit-group/' + id)
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          }) // end api response
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/Group/GroupForm.vue